<template>
  <div style="display: inline">
    <u @click.self.prevent data-container="body" data-toggle="popover" data-placement="bottom" :data-content="hidden" data-trigger="hover">
      {{ displayed }}
    </u>
    <i class="fa fa-info-circle d-print-none" aria-hidden="true"></i>
  </div>
</template>

<script>
export default {
 props: ['displayed', 'hidden'],
 mounted() {
  $('[data-toggle="popover"]').popover()

 }
}
</script>